import React, { useEffect, useState } from "react";

import {
  ChevronLeft,
  ExpandLess,
  ExpandMore,
  LocationOnOutlined,
  NoteOutlined,
  QuizOutlined,
} from "@mui/icons-material";
import {
  Box,
  Card,
  Button,
  Typography,
  IconButton,
  Skeleton,
  CircularProgress,
} from "@mui/material";
import dayjs from "dayjs";
import { enqueueSnackbar } from "notistack";
import { connect, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { EmptyState } from "../../common";
import CandidateExperience from "../../common/CandidateExperience";
import CandidateJobRequirementsMatch from "../../common/CandidateJobRequirementsMatch";
import CandidateQnaCard from "../../common/CandidateQnaCard";
import SelectAssesmentAndCriteriaModal from "../../components/Modals/SelectAssesmentAndCriteriaModal";
import {
  getSingleResume as getSingleResumeAction,
  inviteCandidatesForInterview as inviteCandidatesForInterviewAction,
  selectResumeById,
} from "../../redux/slices/resumeSlice";
import SelectLanguageModal from "../../components/Modals/SelectAssesmentAndCriteriaModal/SelectLanguageModal";
import "../../common/share-button.css";
import ShareResultModal from "../../common/ShareResultModal";
// import Experience from "../../assets/icons/experience.svg";
import Navbar from "../../components/Navbar";
import Sidebar from "../../components/Sidebar";
/* ============================================================================
<ResumeScreeningCandidateFullReport />
============================================================================= */
const ResumeScreeningCandidateFullReport = ({
  user,
  getSingleResume,
  inviteCandidatesForInterview,
}) => {
  const { resumeId } = useParams();
  const navigate = useNavigate();
  const [resumeShow, setResumeShow] = useState(true);
  const [inviteLoading, setInviteLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [
    selectAssessmentAndCriteriaModal,
    setSelectAssessmentAndCriteriaModal,
  ] = useState(false);
  const [pendingAssessmentId, setPendingAssessmentId] = useState(null);
  const [showLanguageSelectModal, setShowLanguageSelectModal] = useState(false);
  const [languagesForInterview, setLangaugesForInterview] = useState([]);
  const [interviewValue, setInterviewValue] = useState(77);
  const [passingCriteriaSet, setPassingCriteriaSet] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [openShareModal, setOpenShareModal] = useState(false);

  const resume = useSelector((state) => selectResumeById(state, resumeId));
  const post = resume?.job;

  const _toggleShareModal = () => setOpenShareModal((prev) => !prev);

  useEffect(() => {
    if (!resume) {
      _getData();
    } else {
      setIsLoading(false);
    }
  }, []);

  const _getData = async () => {
    setIsLoading(true);
    await getSingleResume(resumeId);
    setIsLoading(false);
  };

  const handleInvite = async (assessment_id = post?.assesment_id) => {
    if (!assessment_id && !pendingAssessmentId) {
      return setSelectAssessmentAndCriteriaModal(true);
    }

    if (languagesForInterview?.length === 0) {
      return setShowLanguageSelectModal(true);
    }

    try {
      setInviteLoading("invite");
      await inviteCandidatesForInterview({
        job_post_id: post?.id,
        assessment_id: pendingAssessmentId,
        company_id: user?.company_id,
        resume_ids: [resume?.id],
        languages: languagesForInterview,
        passing_criteria: {
          interview_passing_criteria: interviewValue,
        },
      });
      await _getData();
    } catch (e) {
      enqueueSnackbar("Something went wrong while sending assessment request", {
        variant: "error",
      });
    } finally {
      setInviteLoading(false);
      setInterviewValue(77);
      setLangaugesForInterview([]);
      setPendingAssessmentId(null);
      setShowLanguageSelectModal(false);
      setPassingCriteriaSet(false);
    }
  };

  const extracted_data = resume?.resume?.extracted_data;

  if (!resume) {
    return (
      <Box className="center" height="89vh">
        <EmptyState title="Look's like the resume submition was deleted" />
      </Box>
    );
  }

  return (
    <>
      <Navbar />
      <Sidebar />
      <Card
        sx={{
          // m: 4,
          height: "89vh",
          borderRadius: "10px",
          left: "200px",
          width: "calc(100% - 200px)",
          position: "relative",
          mt: "2%",
        }}
      >
        <Card
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
            px: { xs: 2, md: 4 },
            py: 2,
          }}
        >
          <Box
            display="flex"
            gap={{ xs: 0, md: 2 }}
            flexDirection={{ xs: "column", md: "row" }}
          >
            <Box>
              <IconButton
                size="small"
                sx={{ border: "1px solid #B1B1B1" }}
                onClick={() => navigate(-1)}
              >
                <ChevronLeft sx={{ fontSize: 18, color: "#2d2d2d" }} />
              </IconButton>
            </Box>
            <Box>
              <Typography fontSize="18px" fontWeight={600} color="#48555E">
                {resume?.candidate_name}
              </Typography>
              <Typography fontSize="14px" fontWeight={500} color="#48555E">
                {extracted_data?.candidate_email || "--"}
              </Typography>
            </Box>
            <Box>
              {extracted_data?.total_relevant_experience?.value ? (
                <Box display="flex" alignItems="center" gap={1} mb={1}>
                  <NoteOutlined sx={{ fontSize: "15px", color: "#48555E" }} />
                  <Typography fontSize="14px" fontWeight={600} color="#48555E">
                    {
                      resume?.resume?.extracted_data?.total_relevant_experience
                        ?.value
                    }
                  </Typography>
                </Box>
              ) : null}
              {extracted_data?.address?.value ||
              extracted_data?.location?.value ? (
                <Box display="flex" alignItems="center" gap={1}>
                  <LocationOnOutlined
                    sx={{ fontSize: "15px", color: "#48555E" }}
                  />
                  <Typography fontSize="14px" fontWeight={600} color="#48555E">
                    {extracted_data?.address?.value ||
                      extracted_data?.location?.value}
                  </Typography>
                </Box>
              ) : null}
            </Box>
          </Box>
          <Box
            display="flex"
            gap={2}
            justifyContent="center"
            alignItems="center"
          >
            {/* <button
              type="button"
              class="button"
              onClick={() => setOpenShareModal(true)}
            >
              <span class="fold"></span>

              <div class="points_wrapper">
                <i class="point"></i>
                <i class="point"></i>
                <i class="point"></i>
                <i class="point"></i>
                <i class="point"></i>
                <i class="point"></i>
                <i class="point"></i>
                <i class="point"></i>
                <i class="point"></i>
                <i class="point"></i>
              </div>

              <span class="inner">
                <svg
                  class="icon"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2.5"
                >
                  <polyline points="13.18 1.37 13.18 9.64 21.45 9.64 10.82 22.63 10.82 14.36 2.55 14.36 13.18 1.37"></polyline>
                </svg>
                Share
              </span>
            </button> */}

            {/* {resume?.stage !== "Invited" ? (
              <Button
                variant="main"
                disabled={inviteLoading}
                sx={{
                  fontSize: { xs: 14, md: 18 },
                  py: { xs: 0.5, md: 1 },
                  borderRadius: { xs: "5px", md: "30px" },
                  px: { xs: 2, md: 4 },
                }}
                onClick={() => handleInvite()}
              >
                {inviteLoading ? (
                  <CircularProgress size={20} sx={{ color: "white" }} />
                ) : (
                  "Invite +"
                )}
              </Button>
            ) : null} */}
          </Box>
        </Card>
        <Box display="flex">
          <Box p={4} flexBasis="20%" flexGrow={1}>
            <Box mb={3}>
              <Typography fontWeight={600} fontFamily="Outfit">
                Invited
              </Typography>
              {isLoading ? (
                <Skeleton animation="wave" width="100%" height="30px" />
              ) : (
                <Typography fontSize="15px" fontFamily="Outfit">
                  {/* {dayjs(resume?.created_at).format("LL")} */}
                  {dayjs(resume.created_at).format("MMM DD, YYYY")}
                </Typography>
              )}
            </Box>
            <Box mb={3}>
              <Typography fontWeight={600} fontFamily="Outfit">
                Completed
              </Typography>
              {isLoading ? (
                <Skeleton animation="wave" width="100%" height="30px" />
              ) : (
                <Typography fontSize="15px" fontFamily="Outfit">
                  {/* {dayjs(resume?.resume?.created_at).format("LL")} */}
                  {dayjs(resume?.resume?.created_at).format("MMM DD, YYYY")}
                </Typography>
              )}
            </Box>
            {/* <Box mb={3}>
            <Typography fontWeight={600} fontFamily="Outfit">Extra time breakdown</Typography>
            <Box component="ul" sx={{ listStyleType: 'disc', paddingLeft: 2 }}>
              <li>
                {isLoading ? <Skeleton animation='wave' width='100%' height='22px' /> : <Typography fontSize="15px" fontFamily="Outfit">Not fluent in English +20%</Typography>}
              </li>
              <li>
                {isLoading ? <Skeleton animation='wave' width='100%' height='22px' /> : <Typography fontSize="15px" fontFamily="Outfit">Disability +50%</Typography>}
              </li>
            </Box>
          </Box> */}
            <Box mb={3}>
              <Typography fontWeight={600} fontFamily="Outfit">
                Source
              </Typography>
              {isLoading ? (
                <Skeleton animation="wave" width="100%" height="30px" />
              ) : (
                <Typography fontSize="15px" fontFamily="Outfit">
                  {post?.flow === "2"
                    ? "Resume was manually uploaded"
                    : "Resume received via job post"}
                </Typography>
              )}
            </Box>
          </Box>
          <Box flexBasis="90%" flexGrow={1} p={3} height="70vh" overflow="auto">
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              gap={2}
              mt={2}
            >
              <Box>
                <Typography fontSize="35px" fontWeight={500}>
                  Resume screening
                </Typography>
                <Typography fontSize="20px" fontWeight={500}>
                  {post?.job_name}
                </Typography>
              </Box>
              {post?.custom_qna?.length > 0 && (
                <Box display="flex" gap={1}>
                  <QuizOutlined sx={{ fontSize: "20px", color: "#595959" }} />
                  <Typography color="#595959" fontWeight={500} fontSize="14pxx">
                    {post?.custom_qna?.length} questions
                  </Typography>
                </Box>
              )}
            </Box>
            <Box width="100%">
              <Typography
                mt={2}
                gutterBottom
                textAlign="left"
                fontSize="18px"
                fontWeight={500}
              >
                Match score
              </Typography>
              <Box position="relative" width="100%" height="27px">
                {/* Progress bar background */}
                <Box
                  position="absolute"
                  width="100%"
                  height="100%"
                  borderRadius="12px"
                  bgcolor="#E0E0E0"
                />
                {/* Progress indicator */}
                <Box
                  position="absolute"
                  width={`${resume?.resume_score}%`}
                  height="100%"
                  borderRadius="12px 0 0 12px"
                  bgcolor="primary.main"
                />
                {/* 0% Label */}
                <Typography
                  position="absolute"
                  top="16%"
                  left="10px"
                  transform="translateY(-50%)"
                  variant="body2"
                  color="white"
                  fontWeight="bold"
                >
                  0%
                </Typography>
                {/* 100% Label */}
                <Typography
                  position="absolute"
                  top="16%"
                  right="10px"
                  transform="translateY(-50%)"
                  variant="body2"
                  color="white"
                  fontWeight="bold"
                >
                  100%
                </Typography>
                {/* Percentage popover */}
                <Typography
                  position="absolute"
                  top="-120%"
                  left={`calc(${resume?.resume_score || 0}% - 20px)`}
                  bgcolor="white"
                  border="1px dashed #4FC3F7"
                  borderRadius="16px"
                  px="8px"
                  py="2px"
                  variant="body2"
                  color="#4FC3F7"
                  fontWeight="bold"
                  textAlign="center"
                >
                  {resume?.resume_score || 0}%
                </Typography>
              </Box>
            </Box>

            {extracted_data?.relavant_experience?.value?.length > 0 && (
              <CandidateExperience
                experiences={extracted_data?.relavant_experience?.value}
                extracted_data={extracted_data}
              />
            )}

            <Box borderRadius="10px" gap={2} p={3} bgcolor="#FBFBFB" my={2}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                mb={2}
              >
                <Typography fontSize="22px" fontWeight={500}>
                  Candidate Resume
                </Typography>
                <IconButton onClick={() => setResumeShow(!resumeShow)}>
                  {!resumeShow ? (
                    <ExpandMore sx={{ fontSize: "28px", color: "#8B8B8B" }} />
                  ) : (
                    <ExpandLess sx={{ fontSize: "28px", color: "#8B8B8B" }} />
                  )}
                </IconButton>
              </Box>
              {resumeShow && (
                <embed
                  type="application/pdf"
                  width="100%"
                  height="800px"
                  src={resume?.resume?.s3_annotated_resume}
                />
              )}
            </Box>
            <CandidateJobRequirementsMatch
              score={resume?.score}
              extracted_data={extracted_data}
            />

            {resume?.custom_qna_result?.questions?.map((item) => (
              <CandidateQnaCard qna={item} key={item?.question} />
            ))}
          </Box>
        </Box>

        <SelectAssesmentAndCriteriaModal
          open={selectAssessmentAndCriteriaModal}
          onClose={() => setSelectAssessmentAndCriteriaModal(false)}
          onSelect={(assessmentId) => {
            setPendingAssessmentId(assessmentId);
            handleInvite(assessmentId);
          }}
        />

        <SelectLanguageModal
          open={showLanguageSelectModal}
          actionLoading={inviteLoading}
          passingCriteriaSet={passingCriteriaSet}
          setPassingCriteriaSet={setPassingCriteriaSet}
          interviewValue={interviewValue}
          setInterviewValue={setInterviewValue}
          setShowLanguageSelectModal={setShowLanguageSelectModal}
          onClose={() => {
            setShowLanguageSelectModal(false);
            setLangaugesForInterview([]);
            setPassingCriteriaSet(false);
            setInterviewValue(77);
            setPendingAssessmentId(null);
          }}
          onSelect={(selectedLanguages) => {
            console.log("selected", selectedLanguages);
            setLangaugesForInterview(selectedLanguages);
          }}
          onConfirm={() => {
            handleInvite();
          }}
        />

        <ShareResultModal
          open={openShareModal}
          onClose={_toggleShareModal}
          title={resume?.candidate_name}
          resumeId={resume?.id}
          type="resume"
        />
      </Card>
    </>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

const mapDipatchToProps = {
  getSingleResume: getSingleResumeAction,
  inviteCandidatesForInterview: inviteCandidatesForInterviewAction,
};

/* Export
============================================================================= */
export default connect(
  mapStateToProps,
  mapDipatchToProps
)(ResumeScreeningCandidateFullReport);
